import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';
import {
  DepartmentPicker,
  IDepartmentPickerProps,
} from '@work4all/components/lib/components/entity-picker/departmentPicker/department-picker';

import { reactRefSetter } from '@work4all/utils';

import { LabeledInput } from '../../containers/mask-overlays/locked-inputs';

interface DepartmentPickerFieldProps
  extends Omit<IDepartmentPickerProps<false>, 'multiple'> {
  error?: string;
}

export const DepartmentPickerField = React.forwardRef<
  HTMLDivElement,
  DepartmentPickerFieldProps
>(function DepartmentPickerField(props, ref) {
  const { error, ...pickerProps } = props;
  const { value, onChange } = pickerProps;

  const { t } = useTranslation();

  const wrapperRef = useRef<HTMLDivElement>(null);

  return (
    <div ref={reactRefSetter(wrapperRef, ref)}>
      <EntityPickerPopover
        anchorEl={wrapperRef}
        picker={<DepartmentPicker {...pickerProps} multiple={false} />}
      >
        <LabeledInput
          value={value?.name ?? ''}
          label={t('INPUTS.DEPARTMENT')}
          error={error}
          onClear={() => {
            onChange(null);
          }}
        />
      </EntityPickerPopover>
    </div>
  );
});
